import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Input } from 'semantic-ui-react';

import { StateType } from '../../reducers';
import { formatMessageHelper } from '../../shared/helpers/internationalization';

import { FieldPropsDispatchers, FieldStateProps, InputConnectProps } from './types';
import { FieldSet } from './FieldSet';

const InputEmailConnect = ({
  label,
  id,
  name,
  modifiers = [],
  autoFocus = false,
  tabIndex = 1,
  disabled = false,
  value,
  type = 'text',
  placeholder = '',
  required = false,
  dispatchChangeField,
  dispatchOnBlurField,
  errors,
  min,
  step,
  intl,
}: InputConnectProps & InjectedIntlProps) => (
  <FieldSet id={id} label={label} required={required} modifiers={modifiers} errors={errors}>
    <Input
      id={id}
      name={name}
      type={type}
      value={value}
      autoFocus={autoFocus}
      tabIndex={tabIndex}
      className="form__input"
      disabled={disabled}
      onChange={dispatchChangeField}
      onBlur={dispatchOnBlurField}
      {...(placeholder !== '' ? { placeholder: formatMessageHelper(intl, placeholder) } : {})}
      {...(min !== undefined ? { min } : {})}
      {...(step !== undefined ? { step } : {})}
    />
  </FieldSet>
);

const mapStateToProps = (state: StateType, ownProps: InputConnectProps): FieldStateProps => ({
  value: state.getIn(ownProps.pathValue),
  errors: state.getIn(ownProps.pathErrors),
});

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: InputConnectProps): FieldPropsDispatchers => ({
  dispatchChangeField: (e: any, data: any) => {
    e.persist();
    dispatch(ownProps.onChangeFieldAction(data));
  },
  dispatchOnBlurField: (event: any) => {
    event.persist();
    dispatch(ownProps.onChangeFieldAction(event));
  },
});

export default connect<FieldStateProps, (dispatch: Dispatch<any>, ownProps: InputConnectProps) => FieldPropsDispatchers, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(InputEmailConnect));
